import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
const CART_URL = 'https://italia.kitonline.shop/cart/44568283611271:1';
export function ExtraCTA() {
  return <section className="py-8 px-4 text-center" data-id="element-82">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} className="max-w-md sm:max-w-lg mx-auto" data-id="element-83">
        <p className="text-brand-gold font-bold uppercase text-xs sm:text-sm tracking-widest mb-3" data-id="element-84">
          ⏰ Offerta di lancio attiva — solo per oggi
        </p>
        <CTAButton href={CART_URL} className="w-full" data-id="element-85">
          BLOCCA ORA IL TUO POSTO A €19,90
        </CTAButton>
        <p className="text-xs text-gray-500 mt-3 font-medium" data-id="element-86">
          Pagamento sicuro · Accesso immediato · Garanzia 14 giorni
        </p>
      </motion.div>
    </section>;
}